export const NONE = "none"
export const URL = "url"
export const CLICK_TO_CALL = "click-to-call"
export const EMAIL = "email"
export const FILE = "file"
export const PAGE = "page"
export const TOP_OF_THIS_PAGE = "top"
export const BOTTOM_OF_THIS_PAGE = "bottom"
export const SECTION = "any-section"

export const ALL_OPTIONS = [
    {label: 'None', value: NONE},
    {label: 'URL', value: URL},
    {label: 'Phone number', value: CLICK_TO_CALL},
    {label: 'Email', value: EMAIL},
    {label: 'File', value: FILE},
    {label: 'Page', value: PAGE},
    {label: 'Top of this page', value: TOP_OF_THIS_PAGE},
    {label: 'Bottom of this page', value: BOTTOM_OF_THIS_PAGE},
    {label: 'Section', value: SECTION}
]



// WEBPACK FOOTER //
// ./src/constants/LinkTypes.js